var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSvg151(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 4.33333V2.58333C11.3333 2.26138 11.072 2 10.75 2H3.16667C2.52277 2 2 2.52277 2 3.16667C2 3.81057 2.52277 4.33333 3.16667 4.33333H11.9167C12.2386 4.33333 12.5 4.59472 12.5 4.91667V7.25H10.75C10.1061 7.25 9.58333 7.77277 9.58333 8.41667C9.58333 9.06057 10.1061 9.58333 10.75 9.58333H12.5C12.822 9.58333 13.0833 9.32195 13.0833 9V7.83333C13.0833 7.51138 12.822 7.25 12.5 7.25",
    stroke: "white",
    strokeWidth: 0.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 3.33301V11.4997C2 12.1436 2.52277 12.6663 3.16667 12.6663H11.9167C12.2386 12.6663 12.5 12.405 12.5 12.083V9.74967",
    stroke: "white",
    strokeWidth: 0.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg151);
export default __webpack_public_path__ + "static/media/svg151.d02d42cc4eb4de2f43bc7e190490f4a8.svg";
export { ForwardRef as ReactComponent };